import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  LightDomStyles,
  OutlineElement,
  SlotsController,
} from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './outline-featured-content.css.lit';
import buttonStyles from '../outline-button-baseline/outline-button-baseline.css.lit';
import '../outline-icon-baseline/outline-icon-baseline';
import '../outline-button-baseline/outline-button-baseline';
import { classMap } from 'lit/directives/class-map.js';

type sizeOptions = 'small' | 'large';
type mediaPositions = 'left' | 'right';

/**
 * The OutlineFeaturedContent component
 * @element outline-featured-content
 */
@customElement('outline-featured-content')
export class OutlineFeaturedContent extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, buttonStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  slots = new SlotsController(this);

  /**
   * Determines desktop design of featured content card
   */
  @property({ type: String, attribute: 'size', reflect: true })
  size: sizeOptions = 'large';

  /**
   * Determines if media is on the left or right
   */
  @property({ type: String, attribute: 'media-position' })
  mediaPosition: mediaPositions = 'left';

  /**
   * Sets play button on video if media is video
   */
  @property({ type: Boolean, reflect: true, attribute: 'has-video' })
  hasVideo = false;

  render(): TemplateResult {
    return html`
      <div
        class="
          ${classMap({
          'container': true,
          [this.size]: true,
          'reverse': this.mediaPosition === 'right',
          'has-video': this.hasVideo,
        })}"
      >
        <div class="media-wrapper">
          ${this.slots.conditionalSlot('image', false)}
          ${this.slots.conditionalSlot('media', false)}
          ${this.hasVideo
            ? html`<outline-button-baseline
                ><button
                  class="play-btn btn primary small white rounded"
                  aria-label="small link"
                >
                  <outline-icon-baseline name="eu-triangle" size="2.25rem">
                  </outline-icon-baseline></button
              ></outline-button-baseline>`
            : null}
        </div>
        <div class="content">
          ${this.slots.conditionalSlot('heading', false)}
          ${this.slots.conditionalSlot('body', false)}
          ${this.slots.conditionalSlot('cta', false)}
        </div>
      </div>
    `;
  }
}
